import React from 'react'
import { Table } from 'reactstrap'
import { SetsListItem } from '../ManageSetsComponents'
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText'

/*
  <SetsList 
    searchedSets={props.searchedSets}
    activeSet={props.activeSet}
    handleDeleteSet={props.handleDeleteSet}
  />
*/

export default function SetsList(props) {

  let setsListItems = <tr><td></td><td></td></tr>

  // if any props.searchedSets, sort them by name and then map to SetsListItems ------
  if (props.searchedSets) {

    // convert props.searchedSets to array of objects
    let arrayOfSets = []
    forOwn(props.searchedSets, (val, key, o) => {
      arrayOfSets.push(val)
    })

    arrayOfSets = sortByPropText(arrayOfSets, 'name')

    setsListItems = arrayOfSets.map( (set) => {
      return (
        <SetsListItem 
          name={set.name} 
          id={set.id} 
          key={'SetsListItem' + set.id} 
          activeSet={props.activeSet}
          handleDeleteSet={props.handleDeleteSet}
          locationSearch={props.locationSearch}
        />
      )
    })

  }

  // --------------------------------------------------------------------------

  return (
    <Table responsive size='sm'>
      <thead>
        <tr>
          <th>Set Name</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        {setsListItems}
      </tbody>
    </Table>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetsList.js